'use es6';

import { fromJS } from 'immutable';
import { map } from 'rxjs/operators/map';
import http from 'hub-http-rxjs/clients/apiClient';
import apiClient from 'hub-http/clients/apiClient';
import { HUBSPOT_VIDEO_CRM_OBJECT_TYPE } from '../constants/base';
const URI = 'crm-objects/v2';

const getObjects = response => fromJS(response.results);

export default {
  fetchCrmObjectIdForContent(contentId) {
    const data = {
      count: 1,
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          property: 'hs_content_id',
          value: contentId
        }]
      }],
      objectTypeId: 'CONTENT'
    };
    return http.post('crm-search/search', {
      data
    }).pipe(map(resp => resp.results.length ? resp.results[0].objectId : null));
  },

  fetchCrmObjects(objectTypeId, propertyForDynamicPageSlug) {
    return http.get(`${URI}/${objectTypeId}`, {
      query: {
        properties: [propertyForDynamicPageSlug]
      }
    }).pipe(map(getObjects));
  },

  fetchCrmVideoObjectsByIds(crmObjectIds) {
    return apiClient.post('crm-search/search', {
      data: {
        count: crmObjectIds.length,
        filterGroups: [{
          filters: [{
            operator: 'IN',
            property: 'hs_object_id',
            values: crmObjectIds
          }]
        }],
        objectTypeId: HUBSPOT_VIDEO_CRM_OBJECT_TYPE,
        requestOptions: {
          properties: ['hs_title']
        }
      }
    });
  }

};